// jQuery based alternative to FloatingPanel
Foundation.View.Desktop.RevealPanel = class {
  constructor (options = {}) {
    this.options = Foundation.extend({
      hoverSelector: "",
      clickSelector: "",
      panelSelector: "",
      alignSelector: "",
      alignFunction: function () {}
    }, options || {})

    var {
          hoverSelector,
          clickSelector,
          panelSelector,
          alignSelector,
          alignFunction
        } = this.options

    // The only required param
    if (panelSelector) {
      var focusPanel = function () {
        jQuery(hoverSelector).off('hover', focusPanel)
        jQuery(document).on('mousemove', blurPanel)
        jQuery(panelSelector).show()
        if (alignSelector) {
          jQuery(panelSelector).css('left', `${Math.round(jQuery(alignSelector).position().left)}px`)
        }
        alignFunction()
      }

      var focusPanelTillClickAway = function () {
        jQuery(hoverSelector).off('hover', focusPanel)
        jQuery(document).off('mousemove', blurPanel)
        jQuery(document).on('click', blurPanel)
        jQuery(panelSelector).show()
        if (alignSelector) {
          jQuery(panelSelector).css('left', `${Math.round(jQuery(alignSelector).position().left)}px`)
        }
        alignFunction()
      }

      var blurPanel = function (e) {
        // IE and FF return 1 and Chrome returns 0 for e.which when no key is pressed :-/
        // Check if no key is pressed event is not part of the panel before blur || if esc (27) is pressed
        if ((e.which <= 1 && jQuery(e.target).closest(`${panelSelector}, ${hoverSelector}, ${clickSelector}`).length === 0)
           || e.which === 27) {
          jQuery(document).off('mousemove click', blurPanel)
          resetPanel()
          jQuery(panelSelector).hide()
        }
      }

      var resetPanel = function () {
        if (hoverSelector !== '') {
          jQuery(hoverSelector)
            .off('hover', focusPanel)
            .on('hover', focusPanel)
        }
        if (clickSelector !== '') {
          jQuery(clickSelector)
            .off('click', focusPanelTillClickAway)
            .on('click', focusPanelTillClickAway)
        }
      }

      // init stuff
      resetPanel()
      jQuery(document).on('keydown', blurPanel)
    }
  }
}

window["Foundation"]["View"]["Desktop"]["RevealPanel"] = Foundation.View.Desktop.RevealPanel
